import { render, staticRenderFns } from "./health-legend.vue?vue&type=template&id=9d0b8c6c&scoped=true"
import script from "./health-legend.vue?vue&type=script&lang=js"
export * from "./health-legend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0b8c6c",
  null
  
)

export default component.exports